/* 


@PRAKT


   _____________________________________________________________

   |
   | COOKIE CONSENT
   |
   _____________________________________________________________
*/

/* ______________________________________________________________

   |
   | CLASS
   |
   ______________________________________________________________
*/

export default class CookieConsent {
    constructor() {
        this.to;
        this.counter = 1;
        this.getBanner();
    }

    getBanner() {
        this.banner = document.querySelector( '#shopify-pc__banner' );
        if( !this.banner && this.counter < 10 ) {
            this.to = setTimeout( () => { this.getBanner(); }, 1000 );
            this.counter++;
        } else if( this.banner ) {
            clearTimeout( this.to );
            this.forceHideBanner();
        } else {
            clearTimeout( this.to );
            return;
        }
    }

    forceHideBanner() {
        this.accept = this.banner.querySelector( '#shopify-pc__banner__btn-accept' );
        this.decline = this.banner.querySelector( '#shopify-pc__banner__btn-decline' );

        const hide_banner = () => {
            this.banner.style.display = 'none';
            // console.log('consent 🔨');
        }

        this.accept.addEventListener( 'click', hide_banner );
        this.decline.addEventListener( 'click', hide_banner );
    }
}